import { connect } from 'react-redux';

import { checkUserPermissions } from './userHasPermissionV2';
import { BasePermissionArray } from '../api/permissionsAPI'

interface CanProps {
  /**
  * Тип разрешения. Может быть строкой или массивом строк.
  *
  * @example
  * do='permissionInsert' или
  * do={ [ 'permissionInsert', 'permissionUpdate' ] }
  */
  do?: string | string[]
  /**
  * Тип операции или массив типов операций, для которых проверяются разрешения.
  * Если передается массив, то проверяется наличие разрешения для любой из операций.
  * Разрешения из разных операций объединяются (логическое ИЛИ для boolean полей).
  *
  * @example
  * on='someOperation' или
  * on={ [ 'operation1', 'operation2' ] }
  */
  on?: string | string[]
  /**
  * Если указан то children отобразятся даже в случае отсутствия разрешений
  * Если children является функцией, то в нее будет передан булевый параметр `can`,
  * определяющий наличие или отсутствие разрешений.
  */
  passThrough?: boolean
  /**
  * Если children передается, как функция, то она будет вызвана с параметрами
  * @property {Boolean} can - Результат проверки пользовательских разрешений
  * @property {Object} permissions - Объединенные разрешения пользователя для текущей операции/операций,
  *                                  переданной в {@link Can.props.on}. Если передано несколько операций,
  *                                  разрешения объединяются по принципу ИЛИ (true если есть в любой из операций)
  */
  children: any
  /** @ignore */
  user?: object
  /** @ignore */
  permissions?: BasePermissionArray 
}

const Can = ({
  do: permissionType = 'available',
  on: operationKey = '',
  passThrough = false,
  children,
  user = null,
  permissions = [],
}: CanProps) => {

  const can = checkUserPermissions(user, permissions, operationKey, permissionType);
  
  // Получаем разрешения для всех operationKey (если это массив) и объединяем их
  let operationPermissions = null;
  
  if (Array.isArray(permissions)) {
    const foundPermissions = permissions.filter(item => 
      Array.isArray(operationKey) 
        ? operationKey.includes(item.operationKey)
        : item.operationKey === operationKey
    );
    
    // Объединяем все найденные разрешения в один объект
    // Если есть несколько разрешений, используем логическое ИЛИ (||) для каждого поля
    operationPermissions = foundPermissions.reduce((merged, current) => {
      if (!merged) return { ...current };
      
      const result = { ...merged };
      // Для каждого поля разрешения используем ИЛИ: если true в любом из объектов, то true
      Object.keys(current).forEach(key => {
        if (typeof current[key] === 'boolean') {
          result[key] = result[key] || current[key];
        } else {
          result[key] = current[key];
        }
      });
      return result;
    }, null);
  }
    
  const elements = typeof children === 'function'
    ? children(can, operationPermissions)
    : children;

  return passThrough || can ? elements : null;
};

const mapStateToProps = (state) => {
  return {
    user: state.auth?.profile,
    permissions: state.permissions?.permissions,
  };
};

export default connect(mapStateToProps)(Can);